import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "toast toast-bottom toast-center" }

import { computed } from "vue";
import BasicToast from "./BasicToast.vue";
import { useToastStore } from "@/observables/store/toast-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'InformationToasts',
  setup(__props) {

const toastStore = useToastStore();

const toasts = computed(() => toastStore.getToasts());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id
        }, [
          _createVNode(BasicToast, {
            message: item.message,
            level: item.level
          }, null, 8, ["message", "level"])
        ]))
      }), 128))
    ])
  ]))
}
}

})